import rest from "@/rest-client";
import vuexStore from "@/store/customSaveStore";

export const datasourceElectronicArchive = vuexStore({
  namespaced: true,
  path: "/datasource-electronic-archive",
  state: {
    editedDatasource: null,
  },
  getters: {
    editedDatasource: (state) => state.editedDatasource,
  },
  mutations: {
    editedDatasource: (state, value) => (state.editedDatasource = value),
  },
  actions: {
    addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.post("/datasource-electronic-archive", payload);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationElectronicArchive = vuexStore({
  namespaced: true,
  path: "/electronic-archive",
});
